<template>
  <div class="website-business">
    <div class="g-box">
      <div class="content">
        <div
          @click="toDetail(item)"
          class="item"
          v-for="item in dataList"
          :key="item.id"
        >
          <img class="top" :src="item.image" alt="" />
          <div class="title">{{ item.title }}</div>
          <div class="subtit">
            {{ item.subtitle }}
          </div>
          <div class="more">
            <img src="../../../assets/img/more.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageMain_mx from "../../../mixins/pageMain_mx";

export default {
  mixins: [pageMain_mx],
  data() {
    return {
      dataInfo: {},
      dataList: []
    };
  },
  props: {
    menuId: {
      type: String,
      default: ""
    },
    pageType: {
      type: String,
      default: ""
    }
  },
  components: {},
  async mounted() {
    const dataInfo = await this.getMenuInfo(this.menuId);
    const data = await this.getMenuList({
      pageNum: 1,
      pageSize: 999,
      menuId: this.menuId
    });
    this.dataInfo = dataInfo;
    this.dataList = data;
    console.log(dataInfo, "dataInfo business");
    console.log(data, "data business");
  },
  methods: {
    toDetail(item) {
      window.open(item.url);
    }
  }
};
</script>
<style lang="less">
.website-business {
  background: #003fa7;
  .content {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding-bottom: 120px;
    .item {
      margin-right: 40px;
      margin-top: 130px;
      width: 580px;
      cursor: pointer;
      .top {
        height: 400px;
      }
      .title {
        padding-top: 36px;
        font-size: 24px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #fff;
        line-height: 34px;
      }
      .subtit {
        padding-top: 28px;
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #fff;
        line-height: 28px;
      }
      .more {
        padding-top: 30px;
      }
    }
    .item:nth-child(2n) {
      margin-right: 0;
    }
  }
}
</style>
